import { render, staticRenderFns } from "./addcustomcaseHistory.vue?vue&type=template&id=38299a77&scoped=true"
import script from "./addcustomcaseHistory.vue?vue&type=script&lang=js"
export * from "./addcustomcaseHistory.vue?vue&type=script&lang=js"
import style0 from "./addcustomcaseHistory.vue?vue&type=style&index=0&id=38299a77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38299a77",
  null
  
)

export default component.exports